import { apiClient } from "@/shared/api/client";
import type {
  MarkAllReadResponse,
  Notification,
  UnreadCountResponse,
} from "@/features/notifications/types";

export async function listNotifications(
  limit = 20,
  offset = 0,
): Promise<Notification[]> {
  const { data } = await apiClient.get<Notification[]>("/notifications", {
    params: { limit, offset },
  });
  return data;
}

export async function getUnreadCount(): Promise<number> {
  const { data } = await apiClient.get<UnreadCountResponse>(
    "/notifications/unread-count",
  );
  return data.count;
}

export async function markAsRead(id: string): Promise<Notification> {
  const { data } = await apiClient.post<Notification>(`/notifications/${id}/read`);
  return data;
}

export async function markAllAsRead(): Promise<number> {
  const { data } = await apiClient.post<MarkAllReadResponse>(
    "/notifications/mark-all-read",
  );
  return data.count;
}
